{
  "ascending": "ascendente",
  "ascendingSort": "ordenado por columna {columnName} en sentido ascendente",
  "collapse": "Contraer",
  "columnSize": "{value} píxeles",
  "descending": "descendente",
  "descendingSort": "ordenado por columna {columnName} en orden descendente",
  "expand": "Ampliar",
  "resizerDescription": "Pulse Intro para empezar a redimensionar",
  "select": "Seleccionar",
  "selectAll": "Seleccionar todos",
  "sortable": "columna ordenable"
}
